import React from 'react';
import AppSidebar from '../sidebar/AppSidebar';
import PageHeader from '../common/PageHeader';
import Footer from '../../../../components/common/Footer';

/**
 * 페이지의 전체적인 레이아웃 골격(사이드바, 헤더, 푸터)을 정의하는 컴포넌트.
 */
const InquiryStatusLayout = ({
    isSidebarOpen,
    onToggleSidebar,
    activeTab,
    setActiveTab,
    viewMode,
    setViewMode,
    currentUser,
    recentInquiries,
    isHistoryLoading,
    onSelectInquiry,
    onDeleteInquiry,
    onNewChat,
    children
}) => {
    return (
        <div className="chatbot-theme flex flex-1 h-full min-h-0 bg-white font-sans text-gray-800 overflow-hidden">
            {/* 왼쪽 사이드바 */}
            <AppSidebar
                isOpen={isSidebarOpen}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                viewMode={viewMode}
                currentUser={currentUser}
                recentInquiries={recentInquiries}
                isHistoryLoading={isHistoryLoading}
                onSelectInquiry={onSelectInquiry}
                onDeleteInquiry={onDeleteInquiry}
                onNewChat={onNewChat}
                onToggleSidebar={onToggleSidebar}
            />

            {/* 오른쪽 메인 콘텐츠 영역 */}
            <div className={`flex-1 flex flex-col min-w-0 bg-white relative overflow-hidden transition-all duration-300 ${isSidebarOpen ? 'md:ml-72' : 'md:ml-16'}`}>
                {/* 상단 헤더 */}
                <PageHeader
                    activeTab={activeTab}
                    viewMode={viewMode}
                    setViewMode={setViewMode}
                    onToggleSidebar={onToggleSidebar}
                    currentUser={currentUser}
                    isSidebarOpen={isSidebarOpen}
                />

                {/* 메인 콘텐츠 영역 (InquiryTabContent + ChatInputBar가 들어올 자리) */}
                <main className="flex-1 flex flex-col overflow-hidden px-3 sm:px-6 pt-2 sm:pt-3 pb-0">
                    {children}
                </main>
                
                {/* 하단 푸터 (탭 공통) */}
                <Footer />
            </div>
        </div>
    );
};

export default InquiryStatusLayout;
